module.exports = __webpack_public_path__ + "media/images/games/clash-royale/hiw-3-9662139dde878a0a8567282f4ca4d8a6.jpg";